import { TxpObject } from 'txp-data';

/**
 * Returns internet Message Id of the first entity of the TXP object as
 * internet Message Id for all the entities in an object has same value.
 * @param txpObject Txp object from which origin needs to be extracted
 */
export default function getInternetMessageIdFromTxpObject(txpObject: TxpObject): string {
    if (txpObject) {
        const { txpEntities } = txpObject;
        return txpEntities[Object.keys(txpEntities)[0]].originalEmailInternetMessageId;
    }
    return null;
}
